import { ArrowTopRightOnSquareIcon } from '@heroicons/react/16/solid'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import { UserStoreContext } from '@/stores/UserStore'

// An RO has a detail page when an OL record exists (indicated by `state`).
const hasDetailPage = (row) => row.state != null

const RoNumberCell = ({ row }) => {
  const { isWpcUser } = useContext(UserStoreContext)

  if (hasDetailPage(row) && (row.state !== 'Draft' || isWpcUser)) {
    return (
      <Link
        to={`/dealer/${row.dealer}/repair-order/${row.id}`}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-blue-dark flex items-center gap-1.5 text-blue-800 underline underline-offset-2"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="text-md">{row.roNumber}</span>
        <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5 shrink-0" />
      </Link>
    )
  }

  return <span className="text-charcoal-900 text-md">{row.roNumber}</span>
}

RoNumberCell.propTypes = {
  row: PropTypes.object.isRequired,
}

export default RoNumberCell
